export const STORE_DATA = 'hardware/store_data';
